import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityAlertsSlice } from './get';
import { postCoreDataSecurityAlertSlice } from './post';

import {
	coreDataSecurityAccessAnomalyAlertsReducers,
	coreDataSecurityAccessAnomalyAlertsWatchers
} from './access-anomalies';
import { coreDataSecurityAlertsExportReducers, coreDataSecurityAlertsExportWatchers } from './export';

export const coreDataSecurityAlertsReducers = combineReducers({
	accessAnomaly: coreDataSecurityAccessAnomalyAlertsReducers,
	export: coreDataSecurityAlertsExportReducers,
	get: getCoreDataSecurityAlertsSlice.asyncReducers,
	hide: postCoreDataSecurityAlertSlice.asyncReducers
});

export const coreDataSecurityAlertsWatchers = combineAllWatchers([
	coreDataSecurityAccessAnomalyAlertsWatchers,
	coreDataSecurityAlertsExportWatchers,
	getCoreDataSecurityAlertsSlice.asyncWatchers,
	postCoreDataSecurityAlertSlice.asyncWatchers
]);
